let Test = require('@/mixins/Forms/2019/NRCA_LTI_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection (NA7.6.2.4)`,
                    questions: {
                        question_1: {
                            id: `a`,
                            question: `Automatic time switch controls are programmed with acceptable weekday, weekend, and holiday (if applicable) schedules. (NA7.6.2.4(a), Section 110.9(b)1Aii, Section 130.1(c)1A, Section 130.1(c)4)`,
                            answer: false
                        },
                        question_2: {
                            id: `b`,
                            question: `Document for the owner weekday, weekend, and holidays schedules, as well as all set-up and preference program settings. (NA7.6.2.4(b))`,
                            answer: false
                        },
                        question_3: {
                            id: `c`,
                            question: `The correct time and date are properly set in the time switch. (NA7.6.2.4(c))`,
                            answer: false
                        },
                        question_4: {
                            id: `d`,
                            question: `The battery backup (if applicable) is installed and energized. (NA7.6.2.4(d), Section 110.9(b)1)`,
                            answer: false
                        },
                        question_5: {
                            id: `e`,
                            question: `Override time limit is no more than 2 hours. (NA7.6.2.4(e), Section 110.9(b)1Ai, Section 130.1(c)3B) OR The automatic time switch control's override time is exempt from the 2-hour limit. (EXCEPTION to Section 130.1(c)3B)`,
                            answer: false
                        },
                        question_6: {
                            id: `f`,
                            question: `Override switches remote from area with controlled luminaires have annunciator lights. (NA7.6.2.4(f), Section 130.1(c)3A, Section 130.1(a)) OR The manual override switch is exempt from being in the same enclosed area with the lighting it controls. (EXCEPTION 1 to Section 130.1(a)2) `,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: ` Functional Testing (NA7.6.2.5)`,
                    steps: {
                        step_1: {
                            name: `Step 1: Simulate occupied condition. (NA7.6.2.5(a))`,
                            questions: {
                                question_1: {
                                    id: `a`,
                                    question: `All lights can be turned on and off by their respective area control switch. (NA7.6.2.5(a)1)  <cec-database-of-devices></cec-database-of-devices>`,
                                    answer: false
                                },
                                question_2: {
                                    id: `b`,
                                    question: `The switch only operates lighting in the enclosed space (ceiling-height partitioned area) in which the switch is located. (NA7.6.2.5(a)2, Section 130.1(c)1C)`,
                                    answer: false
                                },
                                question_3: {
                                    id: `c`,
                                    question: `For the area controlled by an automatic time switch control with a time override located in and for the area, the lighting can be turned on manually by initiating the time override. The lighting is configured to remain on for no more than 2 hours, unless the area is exempt from the 2-hour time override limit. (NA7.6.2.5(a)3, Section 110.9(b)1Ai, Section 130.1(c)3B, EXCEPTION to Section 130.1(c)3B)`,
                                    answer: false
                                },
                                question_4: {
                                    id: `d`,
                                    question: `For the area controlled by an automatic time switch control with an automatic holiday shut-off feature, the lighting in the area can be turned off automatically by initiating the holiday shut-off. (NA7.6.2.5(a)4, Section 110.9(b)1Aii, Section 130.1(c)4) <b>OR</b> The automatic time switch control is exempt from incorporating an automatic holiday shut-off feature. (EXCEPTION to Section 130.1(c)4)`,
                                    answer: false
                                },
                                question_5: {
                                    id: `e`,
                                    question: `For the area controlled by an automatic time switch control with manual-on mode configured, the lighting in the area can be turned on manually when it is manually activated. (NA7.6.2.5(a)5, Section 130.1(c)1E) <b>OR</b> The automatic time switch control does not include or utilize a manual-on mode. (Section 130.1(c)1E)`,
                                    answer: false
                                },
                            }
                        },
                        step_2: {
                            name: `Step 2: Simulate unoccupied condition. (NA7.6.2.5(b))`,
                            questions: {
                                question_1: {
                                    id: `a`,
                                    question: `All non-exempt lighting turns off in accordance with the programmed time switch schedules. (NA7.6.2.5(b)1, Section 130.1(c)1A)`,
                                    answer: false
                                },
                                question_2: {
                                    id: `b`,
                                    question: `Manual override switch allows only the lights in the enclosed space (ceiling height partitioned) where the override switch is located to turn on or remain on until the next scheduled shut off occurs. (NA7.6.2.5(b)2, Section 130.1(c)1C, Section 130.1(c)3)`,
                                    answer: false
                                },
                            }
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },

}


